import React, { useState, Suspense, useRef, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/common.scss";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import Home from "container/Home/index";
// import Details from "container/ProductDetails/index";
import Policies from "container/PrivacyPolicies/Policies";
import AboutUs from "container/AboutUs/About";
import Contact from "container/Contact/Contact";
import TermsAndConditions from "container/TermsAndConditions/TermsAndConditions";
import Setup from "container/Setup/Setup";
import { SlideIndexProvider } from "hooks/useSlider";
import WatchNow from "component/WatchNow/index";

const App = () => {
  const [count, setCount] = useState(1);
  const targetSectionRef = useRef(null);
  const [showWatchNow, setShowWatchNow] = useState(() => {
    return JSON.parse(localStorage.getItem("watchNow") || "true");
  });

  useEffect(() => {
    localStorage.setItem("watchNow", JSON.stringify(showWatchNow));
  }, [showWatchNow]);

  return (
    <BrowserRouter>
      {showWatchNow ? (
        <WatchNow
          setShowWatchNow={setShowWatchNow}
          targetSectionRef={targetSectionRef}
        />
      ) : (
        ""
      )}
      <SlideIndexProvider>
        <Header count={count} setCount={setCount} />
        <Suspense fallback={<div></div>}>
          <Routes>
            <Route
              path="/"
              element={<Home targetSectionRef={targetSectionRef} />}
            />
            {/* <Route
            path="/details"
            element={<Details setCount={setCount} count={count} />}
          /> */}
            <Route path="/policies" element={<Policies />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/setup" element={<Setup />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
          </Routes>
        </Suspense>
        <Footer setCount={setCount} />
      </SlideIndexProvider>
    </BrowserRouter>
  );
};

export default App;
